import { useEffect, useState } from 'react';
import { useAuthStore } from '@/store';
import {
  getSavedCustomerToken,
  getCurrentCustomer,
  clearCustomerSession
} from '@/lib/shopifyCustomer';

export function useCustomerAuth() {
  const { customer, setCustomer, clearCustomer } = useAuthStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCustomer() {
      try {
        const token = getSavedCustomerToken();

        if (!token) {
          setLoading(false);
          return;
        }

        const currentCustomer = await getCurrentCustomer(token);

        if (!currentCustomer) {
          clearCustomerSession();
          clearCustomer();
        } else {
          setCustomer(currentCustomer);
        }
      } catch {
        clearCustomerSession();
        clearCustomer();
      } finally {
        setLoading(false);
      }
    }

    loadCustomer();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function logout() {
    clearCustomerSession();
    clearCustomer();
  }

  return {
    customer,
    loading,
    isLoggedIn: !!customer,
    logout
  };
}
